import * as React from 'react';
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Customer from "./Customer";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {axiosInstance} from "../utils/axiosUtils";
import Customers from "./Customers";


export default function FutureMessages({
                                           customersData,
                                           customersToSync,
                                           customersToDelete,
                                           templates,
                                           updateCustomersData
                                       }) {
    const daysOfWeek = [{day: 'ראשון', index: 0}, {day: 'שני', index: 1}, {day: 'שלישי', index: 2}, {day: 'רביעי', index: 3}, {day: 'חמישי', index: 4}, {day: 'שישי', index: 5}, {day: 'שבת', index: 6}];
    const [data, setData] = useState(<div>טוען...</div>);
    const getDaysOfWeekSorted = () => {
        const currentDayIndex = new Date().getDay();
        return daysOfWeek.slice(currentDayIndex).concat(daysOfWeek.slice(0, currentDayIndex));
    }
    const [selectedDay, setSelectedDay] = useState(getDaysOfWeekSorted()[0].index);
    const handleSelectedDayChange = (event, newTabName) => {
        setSelectedDay(newTabName);
    };
    const renderDaysOfWeekTabsSorted = () => {
        const sortedDaysOfWeek = getDaysOfWeekSorted();
        return sortedDaysOfWeek.map((dayObject, index) => <Tab value={dayObject.index} key={index} sx={{color: 'white'}} label={dayObject.day}/>);
    };
    const renderTodayFutureMessages = (futureMessages) => {
        const data = futureMessages.map((item, index) => {
            const futureMessagesWithStatus = item.futureMessageWithActionLogForWeek.map((message) => {
                const date = new Date(message.scheduledMessageDateBy3LastOrders);
                const dayOfWeekIndex = date.getDay();
                message.hide = dayOfWeekIndex !== selectedDay;
                return message;
            });
            if (futureMessagesWithStatus.find(item=>!item.hide)) {
                return (
                    <div key={index}>
                        <Customer updateCustomersData={updateCustomersData} templates={templates}
                                  overridePhoneNumber customer={item.customer}
                                  scheduledMessageWithActionLog={futureMessagesWithStatus}
                                  changed={customersToSync ? customersToSync.includes(item.customer.id) : false}
                                  deleted={customersToDelete ? customersToDelete.includes(item.customer.id) : false}
                        />
                    </div>
                )
            }
            else return null;
        });
        const messagePerDay = data.filter((item) => item !== null);
        if (messagePerDay && messagePerDay.length) return data;
        return <div>אין הודעות לשליחה</div>;
    }
    const renderFutureMessages = (futureMessages) => {
        return (<Box sx={{maxWidth: '460px', margin: "auto"}}>
            {getDaysOfWeekSorted().map((dayObject, index) => (
                <div
                    role="tabpanel"
                    hidden={selectedDay !== dayObject.index}
                    id={`simple-tabpanel-` + dayObject.index}
                    aria-labelledby={`simple-tab-` + dayObject.index}
                >
                    {
                        renderTodayFutureMessages(futureMessages)
                    }
                </div>
            ))}
        </Box>)
    }

    useEffect(() => {
        const futureMessages = renderFutureMessages(customersData);
        setData(futureMessages);
    }, [customersData, customersToSync, customersToDelete, selectedDay]);

    return (
        <Box sx={{p: 3}}>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={selectedDay} onChange={handleSelectedDayChange} variant="scrollable"
                      scrollButtons="auto"
                      aria-label="scrollable auto tabs">
                    {renderDaysOfWeekTabsSorted()}
                </Tabs>
            </Box>
            {data}
        </Box>
    );
}
